import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * H2 heading component
 * Block-level heading component for section titles
 */
const H2 = ({ children, ...props }) => {
  return (
    <Typography variant="h2" component="h2" {...props}>
      {children}
    </Typography>
  );
};

H2.propTypes = {
  children: PropTypes.node.isRequired,
};

export default H2;
